import React from 'react'

import { winOptions } from '@/utils/constants'
import Select from '@/components/forms/Select'
import { FormField } from '@/components/forms/FormField'

export const WinsFilter = ({ filters, ...props }) => {
  const label = 'Wins'
  const accessor = 'isWin'
  const placeholder = 'Wins and Non-wins'

  return (
    <FormField data-testid={`${accessor}-dropdown`}>
      <label>{label}</label>
      <Select
        placeholder={placeholder}
        options={winOptions}
        fixedWidth
        value={filters[accessor]}
        {...props}
      />
    </FormField>
  )
}
